import PropTypes from 'prop-types';
import React, {Component} from 'react';
import CenterWrapper from '~/components/CenterWrapper/CenterWrapper';
import ItemGrid from "~/ui/ItemGrid";
import css from './css.css';
import ItemBar from "~/ui/ItemBar/ItemBar";
import {connect} from "~/redux/connect";
import {getItemLoadingState} from "~/conclude/loading";
import LoadingContainer from "~/components/LoadingContainer/LoadingContainer";
import {pushClose} from "~/actions/navigation_actions";
import { getGridLevel, getItemView, getItemId, getModelPropOrDefault, } from "~/stateGetter";
import identify from "~/identify";
import ItemViewMessageList from "~/ui/MessageList/ItemViewMessageList";
import { VFlexPropagate } from "~/native-ui";

export class ItemView extends Component {
    static propTypes = {
        modelId: PropTypes.string.isRequired,
    };


    filterMessages = (messages) => {
        let { view } = this.props;

        if(view === identify.VIEW_VIEW) {
            return messages.filter((messageData) => {
                return messageData.source !== 'saveResult';
            });
        } else {
            return messages.filter((messageData) => {
                return messageData.type !== 'validation_error';
            });
        }
    };

    renderItem() {
       const { modelId, loading, gridLevel, itemId } = this.props;

        return (
            <VFlexPropagate key={itemId}>
                    <ItemBar loading={loading} modelId={modelId} gridName={this.props.gridName} />
                    <CenterWrapper full py={4} pb={120} bg="gray.200">
                        <ItemViewMessageList className={css.messageList} modelId={modelId} scope="global" />
                        <ItemGrid modelId={modelId} className={css.itemGrid} view={this.props.view} gridName={this.props.gridName} />
                    </CenterWrapper>
            </VFlexPropagate>
       );
    }

    render() {
        let { ready, loading, error, gridLevel } = this.props;

        return (
            <VFlexPropagate >
                <LoadingContainer error={error} ready={ready} loading={loading}>
                    {this.renderItem()}
                </LoadingContainer>
            </VFlexPropagate>
        );
    }
}

const RXItemView = connect(
    (state, {modelId}) => {
        let loadingState = getItemLoadingState(state, modelId);

        return {
            ...loadingState,
            view: getItemView(state, modelId),
            itemId: getItemId(state, modelId),
            gridLevel: (loadingState.ready ? getGridLevel(state, modelId) : null) ?? null,
            gridName: getModelPropOrDefault(state, modelId, 'defaultGrid'),
        }
    },
    (dispatch) => ({
        pushClose: () => dispatch(pushClose())
    })
)(ItemView);

export default RXItemView;